/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';
import { ProdutosService } from '../services/api/estoque/produtos/ProdutosService';

type TAutoCompleteOption = {
  idprod: string;
  label: string;
  descricao: string;
  marca: string;
  vencimento: boolean;
  referencia: string;
  precoSaida: number;
  pvenda: number;
  idproduto: string;
  un: string;
  cfop: number;
  cst: number;
  origem: number;
  cstipi: string;
  cstpis: string;
  cstcofins: string;
  ean: string;
  ncm: string;
};
interface IAutoCompleteProdutoProps {
  isExternalLoading?: boolean;
  filtro?: string;
  un?: (valor: string | undefined) => void;
  referencia?: (valor: string | undefined) => void;
  descricao?: (valor: string | undefined) => void;
  marca?: (valor: string | undefined) => void;
  vencimento?: (valor: boolean | undefined) => void;
  precoSaida?: (valor: number | undefined) => void;
  pVenda?: (valor: number | undefined) => void;
  idproduto?: (valor: string | undefined) => void;
  Cfop?: (valor: number | undefined) => void;
  origem?: (valor: number | undefined) => void;
  cst?: (valor: number | undefined) => void;
  cstipi?: (valor: string | undefined) => void;
  cstpis?: (valor: string | undefined) => void;
  cstcofins?: (valor: string | undefined) => void;
  ean?: (valor: string | undefined) => void;
  ncm?: (valor: string | undefined) => void;
}
export const AutoCompleteProdutoIdProduto: React.FC<IAutoCompleteProdutoProps> = ({ isExternalLoading = false, referencia, descricao, vencimento, precoSaida, pVenda, marca,
  un, idproduto, Cfop, cst, cstipi, cstpis,  cstcofins, origem,ean,ncm,
  filtro = 'descricao',
}) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idprodutos');
  const { debounce } = useDebounce();
  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);
  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');
  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);
useEffect(() => {
}, [opcoes]);
  useEffect(() => {
    setIsLoading(true);
    debounce(() => {
      ProdutosService.getAlllist(busca, selectedId, filtro)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            return;
          }
          if (filtro === 'descricao') {
            setOpcoes(
              result.data.map((produto: any) => ({
                idprod: produto.idproduto,
                label: produto.descricao,
                referencia: produto.referencia,
                marca: produto.marca,
                descricao: produto.descricao,
                vencimento: produto.vencimento ?? false,
                precoSaida: produto.precosaida,
                pvenda: produto.pvenda,
                idproduto: produto.idproduto,
                un: produto.un,
                cfop: produto.cfop,
                cst: produto.cst,
                cstipi: produto.cstipi,
                cstpis: produto.cstpis,
                cstcofins: produto.cstcofins,
                ean: produto.ean,
                ncm: produto.ncm,
                origem: produto.origem,
              }))
            );
          } else if (filtro === 'codbarraentrada') {
            setOpcoes(
              result.data.map((produto: any) => ({
                idprod: produto.idproduto,
                label: produto.codbarraentrada,
                referencia: produto.referencia,
                descricao: produto.descricao,
                marca: produto.marca,
                vencimento: produto.vencimento ?? false,
                precoSaida: produto.precosaida ?? produto.preco ?? 0,
                pvenda: produto.pvenda ?? produto.preco ?? 0,
                idproduto: produto.idproduto,
                un: produto.un,
                cfop: produto.cfop,
                cst: produto.cst,
                cstipi: produto.cstipi,
                cstpis: produto.cstpis,
                cstcofins: produto.cstcofins,
                ean: produto.ean,
                ncm: produto.ncm,
                origem: produto.origem,
              }))
            );
          } else if (filtro === 'codbarrasaida') {
            setOpcoes(
              result.data.map((produto: any) => ({
                idprod: produto.idproduto,
                label: produto.codbarrasaida,
                referencia: produto.referencia,
                descricao: produto.descricao,
                marca: produto.marca,
                vencimento: produto.vencimento ?? false,
                precoSaida: produto.precosaida ?? produto.preco ?? 0,
                pvenda: produto.pvenda ?? produto.preco ?? 0,
                idproduto: produto.idproduto,
                un: produto.un,
                cfop: produto.cfop,
                cst: produto.cst,
                cstipi: produto.cstipi,
                cstpis: produto.cstpis,
                cstcofins: produto.cstcofins,
                ean: produto.ean,
                ncm: produto.ncm,
                origem: produto.origem,
              }))
            );
          } else if (filtro === 'referencia') {
            setOpcoes(
              result.data.map((produto) => ({
                idprod: produto.idproduto,
                label: produto.descricao + ' - ' + produto.referencia,
                referencia: produto.referencia,
                descricao: produto.descricao,
                marca: produto.marca,
                vencimento: produto.vencimento,
                precoSaida: produto.precosaida,
                un: produto.un,
                pvenda: produto.pvenda,
                idproduto: produto.idproduto,
                cfop: produto.cfop,
                cst: produto.cst,
                cstipi: produto.cstipi,
                cstpis: produto.cstpis,
                cstcofins: produto.cstcofins,
                ean: produto.ean,
                ncm: produto.ncm,
                origem: produto.origem,
              })),
            );
          }
        });
    });
  }, [busca, selectedId, filtro, debounce]);
  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;
    const selectedOption = opcoes.find((opcao) => opcao.idprod === selectedId);
    return selectedOption ?? null;
  }, [selectedId, opcoes]);
  useEffect(() => {
    if (autoCompleteSelectedOption) {
      pVenda?.(autoCompleteSelectedOption.pvenda);
      precoSaida?.(autoCompleteSelectedOption.precoSaida);
    }
  }, [autoCompleteSelectedOption]);
  return (
    <Autocomplete
      openText="Abrir"
      closeText="Fechar"
      noOptionsText="Sem opções"
      loadingText="Carregando..."
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, value) => option.idprod === value.idprod}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => {
        setSelectedId(newValue?.idprod);
        idproduto?.(newValue?.idprod);
        referencia?.(newValue?.referencia);
        marca?.(newValue?.marca); 
        descricao?.(newValue?.descricao);
        un?.(newValue?.un);
        vencimento?.(newValue?.vencimento);
        precoSaida?.(newValue?.precoSaida);
        pVenda?.(newValue?.pvenda);
        Cfop?.(newValue?.cfop);
        cst?.(newValue?.cst);
        cstipi?.(newValue?.cstipi);
        cstpis?.(newValue?.cstpis);
        cstcofins?.(newValue?.cstcofins);
        ean?.(newValue?.ean);
        ncm?.(newValue?.ncm);
        origem?.(newValue?.origem);
        setBusca('');
        clearError();
      }}
      popupIcon={isLoading ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label="Pesquisar ítem"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};
